module.exports = __webpack_public_path__ + "static/media/bank.d1b5f848.svg";